import type { DataFetcherV2 } from './DataFetcherV2';

export interface DataFetcherV2ConsumerBaseDeps {
  dataFetcherV2: DataFetcherV2;
}
